<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="搜索校友并绑定"
      center
      width="800px"
      :before-close="$onClose"
      destroy-on-close
      @close="close()"
    >
      <div class="body">
        <div>
          <span>UID</span>
          <el-input
            class="input"
            v-model="uid"
            placeholder="请输入UID"
            size="small"
          ></el-input>
          <span>身份证号码</span>
          <el-input
            class="input"
            v-model="id_card_number"
            placeholder="请输入身份证号码"
            size="small"
          ></el-input>
          <el-button class="search" type="primary" @click="toSearch"
            >搜索</el-button
          >
        </div>
        <div class="body1">
          <el-image
            style="width: 270px; height: 270px; float: left"
            :src="urlPath + info.img_link"
            fit="cover"
          ></el-image>
          <div class="body2">
            <p>中文姓名：{{ info.name_cn }}</p>
            <p>性别：{{ gender[info.gender] }}</p>
            <p>手机号：{{ info.mobile_phone }}</p>
            <p>身份证号码：{{ info.id_card_number }}</p>
            <p>UID：{{ info.uid }}</p>
          </div>
        </div>

        <div class="foot">
          <el-button
            style="width: 106px; float: right"
            size="small"
            type="primary"
            v-preventReClick
            @click="toSave()"
            >通过审核</el-button
          >
          <el-button
            style="width: 106px; float: right; margin-right: 15px"
            size="small"
            @click="close()"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import { formar_gender } from "@/utils/constant.js";
import { isEmpty } from "@/utils/strUtils";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";

export default {
  data() {
    return {
      changVisible: false,
      urlPath: URL_PATH,
      uid: "",
      id_card_number: "",
      id: "",
      info: {},
      gender: formar_gender,
    };
  },
  props: ["radio"],
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
      this.uid = "";
      this.id_card_number = "";
      this.info = {};
    },
    async toSave() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;
      if (!this.radio) {
        await this.$message.error("请选择是否需要缴纳入会费!");
      } else {
        if (!this.info.id) {
          await this.$message.error("先搜索校友");
          return;
        }
        this.toPass();
      }
    },
    //页面初始化时加载的事件
    show(id) {
      this.id = id;
      this.changVisible = true;
    },
    // 搜索校友
    toSearch(value) {
      var params = {
        token: localStorage.getItem("token"),
        uid: this.uid,
        id_card_number: this.id_card_number,
      };
      this.$api
        .searchRegisteredMember(params)
        .then(({ data }) => {
          if (data.Data) {
            this.info = data.Data;
          } else {
            this.info = {};
          }
        })
        .catch(({ error }) => {});
    },
    // 通过审核
    toPass() {
      var params = {
        token: localStorage.getItem("token"),
        id: this.id,
        is_pass: "Y",
        ais_info_id: this.info.id,
        is_pay: this.radio,
      };
      console.log(params);
      this.$api
        .execRegisteredMember(params)
        .then(({ data }) => {
          this.$router.go(0);
        })
        .catch(({ error }) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  background: #ffffff;
  padding: 0 20px;
}
.body1 {
  margin-top: 24px;
  overflow: hidden;
  // float: left;
}
.body2 {
  float: left;
  width: 440px;
}
.body2 p {
  margin-left: 24px;
  margin-bottom: 40px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
}
.body span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.85);
}
.input {
  width: 245px;
  height: 32px;
  margin-left: 5px;
  margin-right: 16px;
}
.search {
  width: 64px;
  height: 32px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  padding: 0;
  word-spacing: 5px;
}
.foot {
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/authenticationRegisterSearchDialog.vue